import CartItem from "../components/CartItem";

export default class CartPage {
    constructor(dom) {
        this.dom = dom;
        this.udateCartcountDown;
        this.is_initQtyControl = false
        this.observer = new MutationObserver(() => {
            console.log("callback that runs when observer is triggered");
            this.initQtyControl();
        });
    }
    async init() {
        console.log("CartPage init");
        this.initQtyControl();
        this.observer.observe(this.dom, { subtree: true, childList: true });
    }
    initQtyControl(){
      // if (this.is_initQtyControl) {
      //   return
      // }
      // this.is_initQtyControl = true
      // console.log('initQtyControl');
        let  qtyControlItems  = this.dom.querySelectorAll('.qty-control');
        if(qtyControlItems.length){
            for( let qtyControlItem of qtyControlItems){
                // console.log(qtyControlItem);
                let tmpcartItem = new CartItem(qtyControlItem);
                tmpcartItem.init();

                qtyControlItem.querySelector('input.qty-input').addEventListener('change',(e)=>{
                    console.log('changeQty');
                    clearTimeout(this.udateCartcountDown);
                    document.querySelector('button[name="update_cart"]').disabled = true;
                    this.udateCartcountDown = setTimeout(()=>{
                        document.querySelector('button[name="update_cart"]').disabled = false;
                        document.querySelector('button[name="update_cart"]').click();
                    }, 1000);


                });
            }
        }
    }
}
